<template>
  <article class="row">
    <div class="col-md-12 d-flex">
      <div
        class="
          w-75
          align-items-center align-items-lg-start
          justify-content-end
          d-flex
          flex-column
        "
      >
        <h4 class="fw-bold">
          {{ this.category }}
        </h4>
        <h5 v-if="categoryDescription">{{ categoryDescription }}</h5>
      </div>
      <div class="w-25 mt-3 d-flex ms-auto align-items-end justify-content-end">
        <div
        role="button"
          :class="
            'btn btn-success text-white p-3 swiper-button-prev ' +
            this.status +
            '-' +
            this.abbr +
            ' ms-auto mr-3'
          "
        ></div>
        <div
        role="button"
          :class="
            'btn btn-success text-white p-3 swiper-button-next ' +
            this.status +
            '-' +
            this.abbr
          " 
        ></div>
      </div>
    </div>
    <div class="col-md-12 loading" v-show="reports.length == 0">
      <div class="d-flex">
        <resource-placeholder v-for="i in 6" :key="i" />
      </div>
    </div>
    <div class="col-md-12" v-show="reports.length !== 0">
      
      <swiper :options="swiperOptions">
        <carousel-item
           v-for="report in reports"
          :key="report.id"
          :report="report"
          :data-language="report.language"
          :learningRow="
            learningRow ? (learningRow.length > 0 ? true : false) : false
          "
          v-show="report.language == language"
        ></carousel-item>

      </swiper>
    </div>
  </article>
</template>

<script>
import CarouselItem from "./CarouselItem.vue";
import ResourcePlaceholder from "./ResourcePlaceholder.vue";

  import {Swiper} from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css';
 import 'swiper/css/swiper.css'
  
export default {
  components: {
    CarouselItem, 
    ResourcePlaceholder, 
    Swiper
  },
  props: {
    reports: {
      type: Array,
      required: true,
    },
    category: {
      type: String,
    },
    categoryDescription: {
      type: String,
    },
    abbr: {
      type: String,
    },
    status: {
      type: String,
    },

    learningRow: {
      type: String,
      required: false,
    },
  },
  methods: {
    getCookie(name) {
      var dc, prefix, begin, end;

      dc = document.cookie;
      prefix = name + "=";
      begin = dc.indexOf("; " + prefix);
      end = dc.length; // default to end of the string

      if (begin !== -1) {
        begin += 2;
      } else {
        begin = dc.indexOf(prefix);
        if (begin === -1 || begin !== 0) return null;
      }

      if (dc.indexOf(";", begin) !== -1) {
        end = dc.indexOf(";", begin);
      }

      return decodeURI(dc.substring(begin + prefix.length, end)).replace(
        /\"/g,
        ""
      );
    },
  },
  computed: {
    language() {
      return this.getCookie("pll_language") ? this.getCookie("pll_language") : "en";
    },
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: "auto",

        // freeMode: true,
        navigation: {
          nextEl: ".swiper-button-next." + this.status + "-" + this.abbr,
          prevEl: ".swiper-button-prev." + this.status + "-" + this.abbr,
        },
        // Some Swiper option/callback...
      },
    };
  },
  mounted() {
        // document.cookie = "pll_language=fr";

    console.log("sorted category:" + this.category, this.reports);
    console.log("lang-cookie", this.getCookie("pll_language"));
  },
};
</script>

